import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format } from "date-fns";

import { Labeled, Badge, Details } from "@lifepay/rc-ui-toolkit";

import TransactionOriginType from "components/processing/transaction/TransactionOriginType";
import SMSStatusLabel from "components/processing/transaction/SMSStatusLabel";
import SMSError from "components/processing/transaction/SMSError";
import SMSStatusBadge from "components/processing/transaction/SMSStatusBadge";

import styles from "./Transaction.m.scss";

function Transaction(props) {
  const { theme, item } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.summary)}>
        <div>{item.transactionId || "-"}</div>
        <div>{item.paymentSystem || "-"}</div>
        <div>{item.pan || "-"}</div>
        <div>{item.authCode || "-"}</div>
        {/* <div>{item.dateCreate && format(item.dateCreate, "YYYY/MM/DD HH:mm:ss") || "-"}</div> */}
        <div>
          {(item.date && format(item.date, "YYYY/MM/DD HH:mm:ss")) || "-"}
        </div>
        <div className={classnames(theme.amounts)}>
          <div className={classnames(theme.label)}>{"Сумма операции"}</div>
          <div className={classnames(theme.amount)}>{item.requestAmount}</div>
          <div className={classnames(theme.currency)}>
            {item.transactionCurrencyCode || "-"}
          </div>
          <div className={classnames(theme.label)}>{"В валюте карты"}</div>
          <div className={classnames(theme.amount)}>{item.billingAmount}</div>
          <div className={classnames(theme.currency)}>
            {item.cardCurrencyCode || "-"}
          </div>
          <div className={classnames(theme.label)}>{"Комиссия"}</div>
          <div className={classnames(theme.amount)}>{item.fee}</div>
          <div className={classnames(theme.currency)}>
            {item.cardCurrencyCode || "-"}
          </div>
        </div>
      </div>
      <div className={classnames(theme.badges)}>
        {/* type */}
        <Badge type={item.isReversal ? "blue" : "green"}>{item.type}</Badge>
        {/* status */}
        <Badge type={item.status === "0" ? "green" : "red"}>
          {item.status === "0"
            ? "Статус: ОК"
            : `Ошибка ${item.status}: ${item.statusName}`}
        </Badge>
        {item.isReversal ? <Badge type={"blue"}>{"отмена"}</Badge> : null}
        {item.hasReversal ? <Badge type={"blue"}>{"есть отмена"}</Badge> : null}
        <SMSStatusBadge status={item.smsStatus} />
        <Badge>{`MCC ${item.mcc}`}</Badge>
        <Badge>{`RRN ${item.rrn}`}</Badge>
      </div>
      <Details>
        {({ open }) => {
          return (
            <div
              className={classnames(
                theme.info,
                open ? theme.open : theme.closed
              )}
            >
              <div>
                <Labeled label={"Тип транзакции"} preset={"const-width"}>
                  {item.type}
                </Labeled>
                <Labeled
                  label={"Статус"}
                  type={item.status === "0" ? "green" : "red"}
                  preset={"const-width"}
                >
                  {item.statusName}
                </Labeled>
                {item.status !== "0" ? (
                  <Labeled
                    label={"Код ошибки"}
                    type={"red"}
                    preset={"const-width"}
                  >
                    {item.status}
                  </Labeled>
                ) : null}

                <Labeled label={"Источник транзакции"} preset={"const-width"}>
                  <TransactionOriginType type={item.originType} />
                </Labeled>
              </div>
              <div>
                <SMSStatusLabel status={item.smsStatus} />
                <SMSError status={item.smsStatus} />
                <Labeled label={"Дата SMS"} preset={"const-width"}>
                  {item.smsDate}
                </Labeled>
                <Labeled label={"Телефон SMS"} preset={"const-width"}>
                  {item.smsPhone}
                </Labeled>
                <Labeled label={"Текст SMS"} preset={"const-width"}>
                  {item.smsText}
                </Labeled>
              </div>
              <div>
                <Labeled label={"Id компании"} preset={"const-width"}>
                  {item.companyId}
                </Labeled>
                <Labeled label={"Компания"} preset={"const-width"}>
                  {item.companyName}
                </Labeled>
                {/* <Labeled label={"Id точки обслуживания"} preset={"const-width"}>
                  {item.merchantId}
                </Labeled> */}
                <Labeled label={"Точка обслуживания"} preset={"const-width"}>
                  {item.merchantName}
                </Labeled>
                <Labeled
                  label={"Страна точки обслуживания"}
                  preset={"const-width"}
                >
                  {item.merchantCountry}
                </Labeled>
                <Labeled label={"Id терминала"} preset={"const-width"}>
                  {item.terminalId}
                </Labeled>
                <Labeled label={"Тип терминала"} preset={"const-width"}>
                  {item.device}
                </Labeled>
                <Labeled label={"Id эквайринга"} preset={"const-width"}>
                  {item.acquiringId}
                </Labeled>
                <Labeled label={"Эквайринг"} preset={"const-width"}>
                  {item.acquiringName}
                </Labeled>
              </div>
            </div>
          );
        }}
      </Details>
    </div>
  );
}

Transaction.displayName = "Transaction";

Transaction.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
};

Transaction.defaultProps = {};

export default themr("@lifepay/Transaction", styles)(Transaction);



// WEBPACK FOOTER //
// ./src/components/list-items/Transaction/Transaction.js